/**
 * ***********************
 * Role Managment Routes Components *
 * ***********************
 */
const RoleManagement = () =>
  import('@/components/Organisations/RoleManagement');
const AddRole = () => import('@/components/Organisations/AddRole');

export default {
  title: 'Roles and Permissions',
  link: '/configuration/roles',
  permission: [
    {
      action: 'view',
      entity: 'system_roles'
    }
  ],
  path: 'roles',
  component: RoleManagement,
  meta: {
    permission: [
      {
        action: 'view',
        entity: 'system_roles'
      }
    ],
    id: 'configuration__roles-permissions-tab'
  },
  children: [
    {
      path: '/configuration/roles',
      redirect: '/configuration/roles/roles-permissions'
    },
    {
      path: 'roles-permissions',
      component: AddRole,
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'system_roles'
          }
        ]
      }
    }
  ]
};
